<script>
  import { createEventDispatcher } from "svelte";
  import axios from "axios";
  import { money, baseUrl } from "./utilities";
  import { stampaCostoLavoro } from "../services/api";
  import Swal from 'sweetalert2';

  
  // import * as all from "../store";
  // import {
  //     startDate, endDate,
  //     ral,
  //     nettoDipendenteMensile,
  //     costoMensile,
  //     costoAnnuale,
  //     nettoDipendente,
  //     numeroMensilita
  //   } from '../store'

  const dispatch = createEventDispatcher();

  let nomeAzienda = "";
  let nomeDipendente = "";
  let tipoCCNL = "";
  let livello = "";
  let mansione = "";

  export let data;
  export let visible = false;

  let downloadLink = null;

  let loading = false;

  async function stampa() {
    loading = true;

    // AZIENDA:                                      {{ NomeAzienda }}
    // Lavoratore:                                  {{ Nome Lavoratore }}
    // Tipologia Contrattuale:               {{ TipologiaContrattuale }}
    // Mansione:                                    {{ Mansione }}
    // Livello:                                          {{ Livello }}
    // NETTO MEDIO MENSILE:            {{ NettoMensile }}
    // LORDO MENSILE:                         {{ LordoMensile }}
    // COSTO AZIENDA MENSILE:         {{ CostoAziendaMensile }}
    // NETTO ANNUALE                         {{ NettoAnnuale }}
    // LORDO ANNUALE (R.A.L.)           {{ LordoAnnuale }}
    // COSTO AZIENDA ANNUALE        {{ CostoAziendaAnnuale }}

    let docData = {
      NomeAzienda: nomeAzienda,
      NomeLavoratore: nomeDipendente,
      TipologiaContrattuale: tipoCCNL,
      Mansione: mansione,
      Livello: livello,
      NettoMensile: money.format(data.nettoDipendenteMensile),
      LordoMensile: money.format(data.ral / data.numeroMensilita),
      CostoAziendaMensile: money.format(data.costoMensile),
      NettoAnnuale: money.format(data.nettoDipendente),
      LordoAnnuale: money.format(data.ral),
      CostoAziendaAnnuale: money.format(data.costoAnnuale),
    };    
    // add with credentials
    try {
      Swal.fire({
        title: 'Download in corso...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const tokenRaw = localStorage.getItem("jwt");
      const token = JSON.parse(tokenRaw);

      const response = await stampaCostoLavoro(docData, token);

      Swal.close();

      close();

    } catch (error) {
      Swal.close();
      console.error("Errore durante la stampa:", error);

      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: 'Si è verificato un errore durante la stampa.',
      });

    } finally {
      loading = false;
    }
  }

  function close() {
    visible = false;
    dispatch('close');
  }

</script>


{#if visible}
  <div class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
    <div class="bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4">
      <div class="flex justify-between items-center bg-indigo-50 py-4 px-6 rounded-t-lg">
        <h2 class="text-xl font-bold text-indigo-700">
          {#if loading} Caricamento... {:else} STAMPA {/if}
        </h2>
        <button on:click={close} class="text-gray-500 hover:text-black text-2xl leading-none">
          &times;
        </button>
      </div>
      <div class="p-6">
        <div class="space-y-4">
          <div class="mb-4">
            <label for="nome_azienda" class="block text-sm text-gray-600 font-semibold uppercase">Nome Azienda</label>
            <input bind:value={nomeAzienda} class="shadow-md mt-1 w-full border border-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" />
          </div>

          <div class="mb-4">
            <label for="nome_dipendente" class="block text-sm text-gray-600 font-semibold uppercase">Nome Dipendente</label>
            <input bind:value={nomeDipendente} class="shadow-md mt-1 w-full border border-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" />
          </div>

          <div class="mb-4">
            <label for="tipologia_contratto" class="block text-sm text-gray-600 font-semibold uppercase">Tipologia Contratto</label>
            <input bind:value={tipoCCNL} class="shadow-md mt-1 w-full border border-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" />
          </div>

          <div class="flex gap-4">
            <div class="w-1/2">
              <label for="livello" class="block text-sm text-gray-600 font-semibold uppercase">Livello</label>
              <input bind:value={livello} class="shadow-md mt-1 w-full border border-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" />
            </div>
            <div class="w-1/2">
              <label for="mansione" class="block text-sm text-gray-600 font-semibold uppercase">Mansione</label>
              <input bind:value={mansione} class="shadow-md mt-1 w-full border border-gray-200 rounded px-3 py-2 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500" />
            </div>
          </div>
        </div>

        <div class="flex justify-end mt-6 gap-2">
          <button class="bg-gray-300 px-4 py-2 uppercase font-bold text-gray-600 rounded hover:bg-gray-400" on:click={close}>
            Chiudi
          </button>
          <button class="bg-indigo-700 text-white font-bold text-sm uppercase px-4 py-2 rounded hover:bg-indigo-500" on:click={stampa}>
            Stampa
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}
